import React, { useState, useEffect } from 'react';
import apiClient from '../../api/client';
import ErrorDisplay from '../common/ErrorDisplay';

const LatestYouTubeVideos = () => {
    const [videos, setVideos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchVideos = async () => {
            try {
                const videoData = await apiClient.getLatestYoutubeVideo();
                setVideos(videoData);
            } catch (err) {
                setError('Failed to fetch the latest YouTube videos.');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchVideos();
    }, []);

    if (isLoading) {
        return <div className="text-center p-6">Loading YouTube videos...</div>;
    }

    if (error) {
        return <ErrorDisplay message={error} />;
    }

    if (!videos || videos.length === 0) {
        return <div className="text-center p-6 text-gray-500">No YouTube videos available.</div>;
    }

    return (
        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
            <h2 className="text-3xl text-center font-bold text-gray-800 mb-6 pb-3 border-b-4 border-blue-600">
                LATEST YOUTUBE VIDEOS
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {videos.map((video) => (
                    <div key={video.id} className="overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300">
                        <a href={video.url} target="_blank" rel="noopener noreferrer" className="block">
                            <div className="relative">
                                <img
                                    src={video.thumbnail}
                                    alt={video.title}
                                    className="w-full h-48 object-cover"
                                />
                                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-white" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                                    </svg>
                                </div>
                            </div>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LatestYouTubeVideos;